export default "/images/vendor/flag-icon-css/flags/1x1/gs.svg?a96857cd4e8cd95734f9af34ce767b6a";